<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" (click)="goBack()"></i>

        <span class="my-auto f16 fw-bold me-2">  
            
            {{
            
            bTankerReport ? ' گزارش وضعیت تانکر ها  ' :
            
            bTankerSource ? 'گزارش شرح تامین به تفکیک منبع ' :
            
            bBaseTanker ? 'گزارش شرح تامین به تفکیک تانکر ' : 'شناسنامه تانکر' 
            
            }} 
            
        </span>

    </div>

</div>

<ng-container *ngIf="bTankerSource || bBaseTanker">

    <form [formGroup]="sourceModel" class="w-100 form rtl row gx-2 gy-2 px-2 px-md-5 mt-1">
    
        <div class="col-12 col-md-3">

            <label> از تاریخ </label>

            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
            
                [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">

                <input dir="ltr" type="text" formControlName="strSDate" class="form-control " />

            </ng-persian-datepicker>

        </div>

        <div class="col-12 col-md-3 ">

            <label> تا تاریخ </label>

            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
            
                [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">

                <input dir="ltr" type="text" formControlName="strEDate" class="form-control " />

            </ng-persian-datepicker>
            
        </div>

        <div class="col-12 col-md-auto d-flex align-items-end pb-1 justify-content-end ">
            <button class="btn mx-md-2 px-5 btn-primary w-100 " type="button" (click)="getTankerBySource()">جستجو</button>
        </div>

        <div class="col-auto d-flex align-items-end pb-1 justify-content-end ">
            <button class="btn mx-md-2 px-4 btn-outline-secondary" type="button" (click)="showAllOnMap()">نقشه</button>
        </div>
    
    </form>

</ng-container>

<main class="rtl px-2 px-md-5 pt-3">

    <span *ngIf="list_Tanker.length > 0"> تعداد <span class="text-danger fw-bold">{{list_Tanker.length | faNum}}</span> مورد یافت شد </span>

    <div class="row gx-2 mt-1 border border-2 ">

        <div class="col-12 p-3" [ngClass]="list_Tanker.length == 0 ? 'col-md-12' : 'col-md-10' ">

            <input type="search" #search (input)="searchBy(search.value)" class="form-control" placeholder="جستجو کنید">

        </div>

        <div *ngIf="list_Tanker.length > 0" class="col-12 col-md-2 text-end p-3">

            <button class="btn btn-success" (click)="exportExcel()">

                <span> خروجی اکسل </span>

                <i class="fa fa-file-excel-o mx-2" aria-hidden="true"></i>

            </button>

        </div>

        <div class="table-responsive" style="max-height: 83vh;">

            <table class="table table-striped" id="Export_Excel">

                <thead class="position-sticky top-0 bg-white">

                    <tr class="col-12 text-center">

                        <ng-container *ngIf="!bTankerReport && !bTankerSource && !bBaseTanker">

                            <th *ngIf="bTanker_Edit"> عملیات </th>
    
                            <th> ش شناسایی </th>
    
                            <th> نام راننده </th>
    
                            <th> موبایل </th>
    
                            <th> پلاک </th>
    
                            <th> نوع خودرو </th>
    
                            <th> <small> حجم کل </small> </th>
    
                            <th> <small> حجم موجود </small> </th>
    
                            <th> <small> حجم آزاد </small> </th>
    
                            <th> نوع ماده </th>
    
                        </ng-container>
    
                        <ng-container *ngIf="bTankerReport && !bTankerSource && !bBaseTanker">
    
                            <th> نام تانکر  </th>
    
                            <th> پلاک </th>
    
                            <th> حوزه خدمت </th>
    
                            <th> ظرفیت  </th>
    
                            <th> موجود  </th>
    
                            <th> ظرفیت خالی  </th>
    
    
                        </ng-container>
    
                        <ng-container *ngIf="bTankerSource && !bTankerReport && !bBaseTanker">
    
                            <th> نام منبع تامین  </th>
        
                            <th> تعداد تغذیه  </th>
    
                            <th> حجم تغذیه  </th>
    
                        </ng-container>

                        <ng-container *ngIf="bBaseTanker && !bTankerReport && !bTankerSource">

                            <th> عملیات </th>
                            
                            <th> نام تانکر  </th>
    
                            <th> پلاک</th>
    
                            <th> حوزه خدمت  </th>
    
                            <th> تعداد تغذیه  </th>

                            <th> حجم تغذیه  </th>

                        </ng-container>

                    </tr>

                </thead>

                <tbody>

                    <ng-container *ngIf="!bTankerReport && !bTankerSource && !bBaseTanker">

                        <tr class="col-12 text-center" *ngFor="let item of list_Tanker">

                            <td *ngIf="bTanker_Edit" class="col-1"> <i class="fa fa-pencil-square-o fa-lg my-2 ms-2 btn btn-secondary" title="ویرایش" (click)="openEditModal(item)"></i> <br></td>
    
                            <td class="col-1">{{item.strUnitID | faNum}}</td>
    
                            <td class="col-2">{{item.strFullName | faNum}}</td>
    
                            <td class="col-1">{{item.strCellNo | faNum}}</td>
    
                            <td class="col-2">{{formatted_pelak(item.strVehicleNo) | faNum}}</td>
    
                            <td class="col-1">{{item.strMobileType_strComment | faNum}}</td>
    
                            <td class="col-1">{{item.fCapacity.toLocaleString() + ' لیتر ' | faNum}}</td>
    
                            <td class="col-1">{{item.fVolume.toLocaleString() + ' لیتر ' | faNum }}</td>
    
                            <td class="col-1">{{item.fEmptyCapacity.toLocaleString() + ' لیتر ' | faNum}}</td>
    
                            <td [ngClass]="!bTankerReport ? 'col-1' : 'col-2' ">{{item.strMaterialType_strComment}}</td>
    
                        </tr>
    
                        <tr class="bg-th-gray col-12 text-center" >
    
                            <td class="col-1 "></td>
    
                            <td class="col-1"></td>
    
                            <td class="col-2"></td>
    
                            <td class="col-1"></td>
    
                            <td class="col-2"></td>
    
                            <td class="col-1">  </td>
    
                            <td class="col-1 text-warning fw-bold ">{{totalfCapacity.toLocaleString() | faNum}}</td>
    
                            <td class="col-1 text-warning fw-bold">{{totalfVolume.toLocaleString() | faNum}}</td>
    
                            <td class="col-1 text-warning fw-bold">{{totalfEmptyCapacity.toLocaleString() | faNum}}</td>
    
                            <td class="col-1"></td>
            
                        </tr>

                    </ng-container>

                    <ng-container *ngIf="bTankerReport && !bTankerSource && !bBaseTanker">

                        <tr class="col-12 text-center" *ngFor="let item of list_Tanker">
    
                            <td class="col">{{item.strFullName | faNum}}</td>

                            <td class="col">{{formatted_pelak(item.strVehicleNo) | faNum}}</td>

                            <td class="col">{{item.strMobileDomain_strComment | faNum }}</td>

                            <td class="col">{{item.fCapacity.toLocaleString() | faNum}}</td>

                            <td class="col">{{item.fVolume.toLocaleString() | faNum}}</td>

                            <td class="col">{{item.fEmptyCapacity.toLocaleString() | faNum}}</td>
    
                        </tr>

                        <tr class=" bg-th-gray col-12 text-center">
                            
                            <td class="col"> </td>

                            <td class="col"> </td>

                            <td class="col"> </td>
    
                            <td class=" text-warning fw-bold ">{{totalfCapacity.toLocaleString()  | faNum}}</td>
    
                            <td class=" text-warning fw-bold">{{totalfVolume.toLocaleString()  | faNum}}</td>
    
                            <td class=" text-warning fw-bold">{{totalfEmptyCapacity.toLocaleString()  | faNum}}</td>

                        </tr>

                    </ng-container>
                    
                    <ng-container *ngIf="bTankerSource && !bTankerReport && !bBaseTanker">

                        <tr class="col-12 text-center" *ngFor="let item of list_Tanker">

                            <td class="col">{{item.strTitle}}</td>

                            <td class="col">{{item.iCount.toLocaleString() | faNum}}</td>

                            <td class="col">{{item.fFeedingValue.toLocaleString() | faNum}}</td>
   
                        </tr>

                        <tr class=" bg-th-gray col-12 text-center">
                               
                            <td class=" text-warning fw-bold "></td>
    
                            <td class=" text-warning fw-bold">{{totalCount.toLocaleString() | faNum}}</td>
    
                            <td class=" text-warning fw-bold">{{totalfCapacity.toLocaleString() | faNum}}</td>

                        </tr>

                    </ng-container>

                    <ng-container *ngIf="bBaseTanker && !bTankerReport && !bTankerSource">

                        <tr class="col-12 text-center" *ngFor="let item of list_Tanker">

                            <td class="col" (click)="openDetails(item)">
                                <i class="fa fa-info-circle fa-lg pointer" title="جزئیات تغذیه"></i>
                            </td>

                            <td class="col">{{item.strFullName | faNum}}</td>

                            <td class="col">{{formatted_pelak(item?.strVehicleNo) | faNum}}</td>

                            <td class="col">{{item?.strMobileDomain_strComment}}</td>

                            <td class="col">{{item.iCount.toLocaleString() | faNum}}</td>

                            <td class="col">{{item.fFeedingValue.toLocaleString() | faNum}}</td>
   
                        </tr>

                        <tr class=" bg-th-gray col-12 text-center">
                               
                            <td class=" text-warning fw-bold "></td>

                            <td class=" text-warning fw-bold "></td>

                            <td class=" text-warning fw-bold "></td>

                            <td class=" text-warning fw-bold "></td>
    
                            <td class=" text-warning fw-bold">{{totalCount.toLocaleString()  | faNum}}</td>
    
                            <td class=" text-warning fw-bold">{{totalfCapacity.toLocaleString() | faNum}}</td>

                        </tr>

                    </ng-container>

               </tbody>

            </table>

        </div>

    </div>

</main>

<div class="modal fade" id="editModal" tabindex="-1" aria-hidden="true" data-backdrop="false" data-bs-backdrop='static' data-keyboard="false">

    <div class="modal-dialog modal-dialog-centered modal-lg">

        <div class="modal-content p-1">

            <div class="modal-header dirI">

                <h5 class="modal-title"> ویرایش </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <form #form="ngForm" (ngSubmit)="editTankerItem(form)" class="row gx-2 gy-1 gy-md-2 px-2 pb-2">

                <div class="col-md-6 col-12">

                    <label for="strName" class="text-danger"> ظرفیت (لیتر) </label>

                    <input type="text"                             
                    
                        oninput="this.value = this.value.replace(/[^0-9]/g,'').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')"

                        dir="ltr" required [(ngModel)]="tankerInfo.fCapacity" name="ffCapacity" class="form-control">

                </div>

                <div class="col-md-6 col-12">

                    <label for="tiMaterialType" class="text-danger"> نوع ماده  </label>

                    <select required class="form-control" [(ngModel)]="tankerInfo.tiMaterialType" name="tiMaterialType">

                        <option *ngFor="let item of list_MaterialType" [value]="item.tiMaterialType"> {{item.strComment}} </option>

                    </select>

                </div>

                <div class="col-md-6 col-12">

                    <label for="strName" class="text-danger"> ارتفاع مخزن (میلی متر) </label>

                    <input type="text"                             
                    
                        oninput="this.value = this.value.replace(/[^0-9]/g,'').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')"

                        dir="ltr" required [(ngModel)]="tankerInfo.iTankHeight" name="iTankHeight" class="form-control">

                </div>

                <div class="col-md-6 col-12">

                    <label for="strName" class="text-danger"> عرض مخزن (میلی متر) </label>

                    <input type="text"                             
                    
                        oninput="this.value = this.value.replace(/[^0-9]/g,'').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')"

                        dir="ltr" required [(ngModel)]="tankerInfo.iTankWidth" name="iTankWidth" class="form-control">

                </div>

                <div class="col-md-6 col-12">

                    <label for="strName" class="text-danger"> طول مخزن (میلی متر) </label>

                    <input type="text"                             
                    
                        oninput="this.value = this.value.replace(/[^0-9]/g,'').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')"

                        dir="ltr" required [(ngModel)]="tankerInfo.iTankLength" name="iTankLength" class="form-control">

                </div>

                <div class="col-12 mt-3 text-end">

                    <button type="submit" class="btn px-5 btn-primary">

                        <span> ویرایش </span>
                
                    </button>

                    
                </div>

            </form>

        </div>

    </div>

</div>

<ng-container *ngIf="isLoading">

    <div class="school_loading">

        <img src="../../../../assets/Img/school_2.gif" alt="loading">

    </div>

</ng-container>